import styled from 'styled-components'
import { Card } from 'components/Card'
import {
  HEADER_HEIGHT_DESKTOP,
  HEADER_HEIGHT_MOBILE_FULL,
} from 'constants/common'
import { SPACE } from 'Theme'

export const StyledCard = styled(Card)`
  scroll-margin-top: ${({ isMobile = false }) =>
    `calc(${isMobile ? HEADER_HEIGHT_MOBILE_FULL : HEADER_HEIGHT_DESKTOP} + ${
      SPACE.PX_24
    })`};
`
